<script>
	import {push, pop, replace} from 'svelte-spa-router';
    import { iddistribuidor, nombre } from '../store/distribuidor.js';
	import { jwt } from "../store/index.js";
	let correo;
	let password;
	async function logueo(){
		const url = 'php/logueo.php?correo=' + correo + '&password=' +  password;
        let res = await fetch(url)
        res = await res.json()
        if(res.status == 0){
			alert(res.message);
		} else{
				if(res.data.idstripe != ""){
				nombre.set(res.data.distribuidor);
				iddistribuidor.set(res.data.iddistribuidor);
				jwt.set(res.data.iddistribuidor);
				replace("/perfil");
			}else{
				const data1 = new FormData()
				data1.append('nombre', res.data.distribuidor);
				data1.append('correo', res.data.correo);
				let resa = await fetch('php/pago.php', {
					method : "POST",
					body: data1
				})		
				resa = await resa.json()
				console.log(resa);
				const data2 = new FormData()
				data2.append('id', res.data.iddistribuidor);
				data2.append('idstripe', resa);
				let resa1 = await fetch('php/update-iddib.php', {
					method : "POST",
					body: data2
				})		
				nombre.set(res.data.distribuidor);
				jwt.set(res.data.iddistribuidor);
				iddistribuidor.set(res.data.iddistribuidor);
				push("/perfil");
			}
		}
	}
</script>
<div class="conten_login">
	<div class="cuadro_blanco">
		<div class="adjust">
			<center>
				<img src="./img/logo.png" alt="">
			</center>
			<form on:submit|preventDefault={logueo} class="form_login">
				<input type="email" class="input_login" placeholder="Email" bind:value={correo} required>
				<input type="password" class="input_login" placeholder="Password" bind:value={password} required>
				<button type="submit" class="boton_login">LOGIN</button>
			</form>
			<input type="submit" class="forgot" value="Forgot password?">
		</div>
	</div>
</div>